import { Checkbox } from '@material-ui/core';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';
import Colors from '../../constants/color';

export const ContainerExt = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 16px;
  border-radius: 6px;
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #dddddd;

  span {
    color: ${Colors.grey1};
  }
`;
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;

  @media only screen and (max-width: 600px) {
    width: 100%;
    padding: 0px 30px 0px 30px;
  }
`;

export const RowInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ColumnForm = styled.div`
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;
export const RowForm = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 30px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
export const Footer = styled.div`
  background-color: #F2F2F2;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: 50%;
`;
export const ContainerTurn = styled.div`
  display: flex;
  flex-direction: column;
`;
export const DaysContainer = styled.div`
  display:  flex;
  justify-content: space-between;
  flex-direction:  row;
`;
export const PeriodoContainer = styled.div`
  margin: 0px 0px 20px 10px;
  display:  flex;
  justify-content: space-evenly;
  flex-direction:  column;
`;
export const RowSelect = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
`;
export const FooterTurn = styled.div`
  display: flex;
  flex-direction: row;
`;
export const FooterTurnContainerRight = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 95px;

div {
  width: 200px;
  margin-right: 6px;
}
`;
export const Padding = styled.div`
  display: flex;
  width: 100%;
  margin-right: 10px;
`;
export const ContainerImage: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;

  height: 300px;
  margin-bottom: 20px;

  /* @media only screen and (max-width: 600px) {
    margin-top: 20px;
  } */
`;
export const ContainerImageBase: any = styled.div`
  margin-top: -20px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${(props: any) => props.img}); /* The image used *//* Used if the image is unavailable */
  height: 300px;
  flex: 1;
  width: 100%;
  background-size: cover;
  border-radius: 16px;
`;
export const ContainerImageVoid: any = styled.div`
  display: flex;
  max-width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 300px;
  margin-top: -20px;
  margin-bottom: 20px;
  background-color: ${Colors.grey1};
  border-radius: 16px;

  @media only screen and (max-width: 600px) {
    margin-top: 20px;
  }
`;
export const ContainerLoading: any = styled.div`
display: flex;
justify-content: center;`;

export const style = {
  column: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    marginBottom: 40,
  },
  input: {
    display: 'flex',
    marginBottom: 30,
  },
  text: {
    fontSize: 12,
    marginRight: 10,
    color: Colors.white,
    backgroundColor: Colors.grey1,
    fontFamily: 'Graphik-Regular',
  },
  textSave: {
    fontSize: 12,
    marginRight: 10,
    color: Colors.white,
    backgroundColor: 'green',
    fontFamily: 'Graphik-Regular',
  },
  textButton: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 15,
    marginLeft: 16,
    color: Colors.white,
    backgroundColor: Colors.grey1,
    fontFamily: 'Graphik-Regular',
  },
  textButtonTurno: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 15,
    marginLeft: 0,
    color: Colors.white,
    backgroundColor: Colors.grey1,
    fontFamily: 'Graphik-Regular',
  },
};
export const ContainerTurnRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  align-items:  center;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const ContainerTurnColum = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 60px;
  margin-top: 8px;
`;
export const ContainerBtn = styled.div`
  display: flex;
  margin-top: 8px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  height: 60px;
`;
export const PDV = styled.div`
  height: 50;
  border-radius: 30px;
  font-size: 10px;
  text-align: center;
  padding-top: 4px;
  color: grey;
  width: 40px;
  font-weight: bold;
  border: 2px solid ${Colors.grey3};
`;
export const RowBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;
export const ContainerForm = styled.div`
  flex-direction: row;
  display: flex;
  margin-top: 40px;

  @media only screen and (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;
export const ContainerColumnUsers = styled.div`
  flex-direction: column;
  width: 50%;
  align-items: center;
  padding: 0px 20px 0px 20px;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
export const ContainerRownHeader = styled.div`
  flex-direction: row;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
`;
export const ContainerColumnList = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  padding: 0px 20px 0px 20px;
`;
export const SubContainerHedaer = styled.div`
  flex-direction: row;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  margin-left: 30px;
`;
export const Small = styled.small`
  font-size: 14px;
  font-family: 'Graphik-Regular';
`;
export const DescriptionPhoto: any = styled.small`
  font-size: 14px;
  padding: 4px 20px 4px 20px;
  background-color: ${Colors.grey2};
  color: ${Colors.white};
  border-radius: 20px;
  font-family: 'Graphik-Regular';
`;
export const SmallForm: any = styled.small`
  font-size: 14px;
  font-family: 'Graphik-Bold';
  color: ${Colors.grey2};
  margin-bottom: 6px;
`;

export const PlaceName = styled.strong`
  font-family: 'Graphik-Semibold';
`;

export const SizedBox = styled.div`
  height: 20px;
`;
export const ImageIcon = styled(LazyLoadImage)`
  height: 20px;
  width: 16px;
`;
export const ImageIconSucess = styled(LazyLoadImage)`
  width: 50px;
`;
export const Rounded: any = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: ${Colors.grey1};
  width: 60px;
  border-radius: 100%;
  border: 1px solid ${(props: any) => props.color};
`;
export const TextFile: any = styled.small`
  font-size: 16px;
  margin-top: 10px;
  font-family: 'Graphik-Regular';
  color: ${Colors.white};
  margin-bottom: 6px;
`;
export const SubTextFile: any = styled.small`
  font-size: 14px;
  font-family: 'Graphik-Regular';
  color: ${Colors.grey5};
  margin-bottom: 6px;
`;

export const SmallPorcent = styled.strong`
  font-size: 14px;
  opacity: 10;
  margin-top: 10px;
  margin-bottom: 10px;
  color: ${Colors.grey2} ;
  font-family: 'Graphik-Bold';
  text-transform: capitalize;
  word-break: keep-all;
`;
export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0px 20px 15px 20px;
  height: 100%;
  min-width: 350px;
  justify-content: center;
  width: 35%;
`;
export const CheckboxCustom = styled(Checkbox)`
  flex: 1;
  width: 80px;
`;
export const LeftContainerFooter = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Space = styled.div`
  width: 10px;
`;
export const ScrowView = styled.div`
  width: 100%;
  min-height: 65%;
  height: 100px;
  overflow-y: scroll;
`;
